
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/codebuild/output/src2826043929/src/seb-brand-platform/apps/wmf/sentry.client.config.ts")
            }
          });